import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {ITherapeuticIndication, ITherapeuticIndicationAdmin, IUpdateResourceUrlPayload} from '../../entities/TherapeuticIndication/TherapeuticIndication';

export class TherapeuticIndicationApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/TherapeuticIndications`;

    public static apiUrls = {
        getAll: `${TherapeuticIndicationApi.baseApiUrl}`,
        getById: `${TherapeuticIndicationApi.baseApiUrl}/:id`,
        getAllForAdmin: `${TherapeuticIndicationApi.baseApiUrl}/Admin`,
        updateResourceUrl: `${TherapeuticIndicationApi.baseApiUrl}/:id/ResourceUrl`,
        getResourceUrl: `${TherapeuticIndicationApi.baseApiUrl}/:id/ResourceUrl`,
    };

    public static async getAll(): Promise<ITherapeuticIndication[]> {
        return this.sendApiRequest<ITherapeuticIndication[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getAll,
        });
    }

    public static async getById(id: string): Promise<ITherapeuticIndication> {
        return this.sendApiRequest<ITherapeuticIndication>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getById,
            id: id
        });
    }

    public static async getAllForAdmin(): Promise<ITherapeuticIndicationAdmin[]> {
        return this.sendApiRequest<ITherapeuticIndicationAdmin[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getAllForAdmin,
        });
    }

    public static async updateResourceUrl(id: number, data: IUpdateResourceUrlPayload): Promise<boolean> {
        return this.sendApiRequest<boolean>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.updateResourceUrl,
            id: String(id),
            data,
        });
    }

    public static async getResourceUrl(id: number): Promise<string> {
        return this.sendApiRequest<string>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getResourceUrl,
            id: String(id),
        });
    }
} 